import {
  AppstoreOutlined,
  ArrowLeftOutlined,
  AuditOutlined,
  EditOutlined,
  HomeOutlined,
  SolutionOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Col, Layout, Menu, Row, Typography } from "antd";
import { useEffect, useRef, useState } from "react";
import BasicInfos from "./BasicInfoes";
import CustomerDetails from "./CustomerDetails";
import AdvisorInfoes from "./AdvisorInfoes";
import PropertyInfoes from "./PropertyInfoes";
import RentalInfoes from "./RentalInfoes";
import { useNavigate, useSearchParams } from "react-router-dom";
import endPoints from "../../EndPoints"
import { useQueryClient } from "react-query";
import GeneralCondition from "./GeneralConditions";
import ResponsiveMenu from "apps/Common/ResponsiveMenu";


const AddOrUpdateContractIndex = () => {
  const { Sider, Content } = Layout;
  const queryClient = useQueryClient()
  const {Text} = Typography
  const [selectedKey, setSelectedKey] = useState<any>("basicInfoes");
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const contractId = searchParams.get("contractId");
      const containerRef = useRef(null)
    const key = searchParams.get("key");

    useEffect(()=>{
      if(key)
      {
        setSelectedKey(key)
      }
    },[])
  const items = [
    {
      key: "basicInfoes",
      label: "Temel Bilgileri",
      icon: <AppstoreOutlined />,
     
    },
    {
      key: "customerDetails",
      label: "Müşteri Detayları",
      icon: <UserOutlined />,
      disabled: contractId ? false : true,
    },

    {
      key: "advisorInfoes",
      label: "Danışman Detayı",
      icon: <SolutionOutlined />,
      disabled: contractId ? false : true,
    },
    {
      key: "propertyInfoes",
      label: "Mülk Bilgileri",
      icon: <HomeOutlined />,
      disabled: contractId ? false : true,
    },
    {
      key: "rentalInfoes",
      label: "Kira Şartları",
      icon: <AuditOutlined/>,
      disabled: contractId ? false : true,
    },
    {
      key: "generalConditions",
      label: "Genel Şartlar",
      icon: <EditOutlined/>,
      disabled: contractId ? false : true,
    },
   
  ];

  return (
    <Col span={24} className="">
       <span
        className="!flex gap-1 items-center !my-6 !border !rounded-md hover:cursor-pointer !border-gray-200 !w-[130px] !p-2 !ml-1 "
        onClick={() => {
          queryClient.resetQueries({
            queryKey: endPoints.getContractList,
            exact: false,
          });
          navigate("/admin/panel?activePanelMenu=contract")
        }}
      >
        <ArrowLeftOutlined className="!text-indigo-500 " />
        <Text className="!text-indigo-500" >Geriye Dön</Text>
      </span>
      <Row gutter={[20,20]}  className="xl:!h-screen !bg-white" ref={containerRef}  >
      <Col xs={24}   xl={6} xxl={4} className="!rounded-lg ">
      <ResponsiveMenu
      
        containerRef={containerRef}
          currentStep={selectedKey}
          setCurrentStep={setSelectedKey}
          defaultSelectedKeys={["0"]}
          menuItems={items}
          onClick={(e) => setSelectedKey(e.key)}
        />
      </Col>
      <Col xs={24}  xl={18} xxl={20} className="  ">
        <Content className="!bg-white ">
        {(() => {
            if (selectedKey === "basicInfoes") {
              return (
                <>
                 <BasicInfos setSelectedKey={setSelectedKey}/>
                </>
              );
            } else if (selectedKey === "customerDetails") {
              return (
                <>
                 <CustomerDetails setSelectedKey={setSelectedKey}/>
                </>
              );
            } else if (selectedKey === "advisorInfoes") {
              return (
                <>
                 <AdvisorInfoes setSelectedKey={setSelectedKey}/>
                </>
              );
            }

            else if (selectedKey === "propertyInfoes") {
              return (
                <>
                  <PropertyInfoes setSelectedKey={setSelectedKey}/>
                </>
              );
            }

            else if (selectedKey === "rentalInfoes") {
              return (
                <>
                 <RentalInfoes setSelectedKey={setSelectedKey}/>
                </>
              );
            }
            else if (selectedKey === "generalConditions") {
              return (
                <>
                 <GeneralCondition/>
                </>
              );
            }
           
            

            return <></>;
          })()}
        </Content>
      </Col>
      </Row>
    
    </Col>
  );
};

export default AddOrUpdateContractIndex;
